exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".trackingImpressionImg___1opPr {\n  display: none;\n}\n", "", {"version":3,"sources":["/causefundraisernodeweb-ci-1233/workspace/causefundraisernodeweb-ci-1233/public/js/components/TrackingImpressionPixel/style.less"],"names":[],"mappings":"AAAA;EACE,cAAc;CACf","file":"style.less","sourcesContent":[".trackingImpressionImg {\n  display: none;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"trackingImpressionImg": "trackingImpressionImg___1opPr"
};